import { Container, Header, Tabs } from "@amzn/awsui-components-react";
import UploadSnapshot from "./snapshot/UploadSnapshot";
import DownloadSnapshot from "./snapshot/DownloadSnapshot";
import I18nProvider from "@amzn/awsui-components-react/polaris/i18n";
import enMessages from "@amzn/awsui-components-react/polaris/i18n/messages/all.en";

export default function App() {
  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <Container header={<Header>Tax Excel Add In</Header>}>
        <Tabs
          tabs={[
            {
              label: "Take Snapshot",
              id: "takeSnapshot",
              content: <UploadSnapshot />,
            },
            {
              label: "Download Snapshot",
              id: "downloadSnapshot",
              content: <DownloadSnapshot />,
            },
          ]}
        />
      </Container>
    </I18nProvider>
  );
}
